export default "__VITE_ASSET__D$qkROAb__"